var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"cxm-PageNavigationButton",class:{'-active': _vm.active }},_vm.$listeners),[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }